import { DownloadItemType } from "../../types";
import { getRequestWrapper } from "../../utilities";

type getVersionsByAppIdParams = {
  store_id: string | number;
};

// Response ----------

export type getVersionsByAppIdResponse = { body: DownloadItemType[] };

// Request ----------

export function getVersionsByAppId(
  id: string,
  params?: getVersionsByAppIdParams
): Promise<getVersionsByAppIdResponse> {
  return getRequestWrapper<
    getVersionsByAppIdParams,
    getVersionsByAppIdResponse
  >({
    url: `${ENV_SETTINGS.API_URL}/apps/${id}/versions`,
    params,
  });
}
